import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent"
import Swiper, {Navigation, Pagination} from 'swiper';


class OnBoardingModalComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element);
        this.prev = this.element.querySelector('.on-boarding-modal__prev');
        this.next = this.element.querySelector('.on-boarding-modal__next');
        this.body = document.querySelector('body');
        // this.campaignCode = dlover2025;

        this.init();
    }

    checkMissionStatus() {
        let url = `/api/1.0/loyalty/campaign/dlover2025/mission/explore-dlover/status`;
        youserxp.ajax(url, {
            method: 'GET',
            auth: true
        }).then(
            (obj) => {
                this.checkResult(obj.body);
            },
            () => {});
    }

    checkResult(data) {
        if (!data.canExecuteMission) return;
        this.initModal();

    }


    initModal() {
        this.swiper = new Swiper(this.element.querySelector('.swiper'), {
            centeredSlides: true,
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 1,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: {
                nextEl: this.next,
                prevEl: this.prev,
            },
        });

        this.addModalListener();
        this.modal.openModal();
    }


    addModalListener() {
        this.element.querySelector('.on-boarding-modal__exit').addEventListener('click', () => this.modal.closeModal());
        this.element.querySelector('.generic-modal__close').addEventListener('click', () => this.modal.closeModal());
        this.element.querySelector('.on-boarding-modal__confirm').addEventListener('click', () => {
            this.modal.closeModal();
            this.completeMission();
        });
    }

    completeMission() {
        this.element.classList.add('loading');
        youserxp.ajax(`/api/1.0/loyalty/campaign/dlover2025/mission/explore-dlover/completed`,
            {method: 'POST', auth: true},
            {}, 'json').then(
            (data) => window.location.href = '/reserved/esplora-dlovers-completata',
            (err) => this.element.classList.remove('loading')
        );
    }


    completeMissionFromCard() {
        this.ctaOnboard = this.body.querySelector('.partecipa-onboarding');

        if (this.ctaOnboard) {
            this.ctaOnboard.addEventListener('click', () => {
                this.checkMissionStatus();
            })
        }
    }

    init() {
        document.addEventListener('show-on-boarding-invitation', () => this.checkMissionStatus());
        this.completeMissionFromCard();
        
    }
}

export default OnBoardingModalComponent;
